<template>

  <div @click="talk" >
   {{textPrompt}}
   <audio ref="audioTalk" :src="audio" ></audio>
  </div>
 
</template>

<script>
var self
export default {
  props: {
   audio:{default:null},
   textToSpeak:{default:"Say Nothing"},
   charVoiceIndex:null,
   textPrompt:{default:"Listen to"},
  },
  data() {
    return {
        voices:null,
        voiceIndex:0,
        englishVoices:[],
        isTalking:false,
        speech:null,
        synth:window.speechSynthesis
    };
  },
  mounted(){
      //this.getVoices()
      self=this
  },
  computed: {
    
  },
  methods: {
    getVoices(){
        this.speech = new SpeechSynthesisUtterance();
        var self=this
        this.englishVoices=[]
        window.speechSynthesis.onvoiceschanged = function() {
            window.speechSynthesis.getVoices();
            self.voices = window.speechSynthesis.getVoices();
            for(var v in self.voices){
                 console.log(v,self.voices[v].name,self.voices[v].lang)
                if(self.voices[v].lang.indexOf("en")>-1){
                    self.englishVoices.push(self.voices[v])
                }
            }
           
             console.log("ENGLISH",self.englishVoices)
        }
    },
    getEnglish(){

    },
    endTalk(){
       this.$emit("speechEnded")
       self.isTalking=false
    },
   talk(){
       if (this.audio) { 
           if(!this.isTalking){
                this.$refs.audioTalk.play()
                this.$refs.audioTalk.onended = function(e) {
                        self.endTalk()
                };
                this.isTalking=true
           }else{
               this.$refs.audioTalk.pause()
               self.endTalk()
           }
           return 
        }
				//var msg = new SpeechSynthesisUtterance('The Beaufort Bomber was also known as the Tin Goose. More of those planes were lost in accidents or mechanical failures than in the line of duty! The Australian Government kept them around until the end of the war, they needed as much weaponry as they could get, especially in Northern Australia. The captain, officer Fred Atkinson reported having to make a water landing near the northwest tip of East Arnhem Land – closer to Yirrkala. They might have chosen to land at Dolywoi Bay. It’s close enough to caves like those that they reported seeing.');
				//window.speechSynthesis.speak(msg);
                if(!this.isTalking){
                    this.speech = new SpeechSynthesisUtterance();
                    if(!isNaN(this.charVoiceIndex)){
                        console.log("HAS VOICE",this.charVoiceIndex)
                        this.speech.voice = this.englishVoices[this.charVoiceIndex];
                    }else{
                        console.log("NO VOICE",this.voiceIndex)
                        this.speech.voice = this.englishVoices[this.voiceIndex];
                    }
                    console.log(this.charVoiceIndex,"--",this.englishVoices[this.voiceIndex],this.voiceIndex)

                    this.speech.voiceURI = 'native';
                    this.speech.volume = 1; // 0 to 1
                    this.speech.rate = 1; // 0.1 to 10
                    this.speech.pitch = 1; //0 to 2
                    this.speech.text = this.textToSpeak || 'The Beaufort Bomber was also known as the Tin Goose.';
                    
                    this.speech.lang = 'en-US';

                    this.speech.onend = function(e) {
                        self.endTalk()
                    };
                    this.voiceIndex=(this.voiceIndex+1)%this.englishVoices.length
                    this.isTalking=true
                    speechSynthesis.speak(this.speech);
                }else{
                    
                    this.synth.cancel()
                }

			}
  },
  beforeDestroy(){
      this.synth.cancel()
  }
};
</script>

<style lang="scss">

</style>